import { AuthenticationService } from './AuthenticationService'

export default function Signout() {
    AuthenticationService.logout()
    document.location = '/'
    return null
}